import {
  ContentChild,
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { NgFlowDesignerNodeDirective } from './ng-flow-designer-node.directive';
import { CyElement } from './interfaces';
import * as cytoscape from 'cytoscape';
import { NgFlowDesignerComponent } from './ng-flow-designer.component';
import { Subject } from 'rxjs';
import { NgFlowDesignerEdgeControllerDirective } from './ng-flow-designer-edge-controller.directive';
import { NgFlowDesignerService } from './ng-flow-designer.service';

@Directive({
  selector: '[ngFlowDesignerOutput]',
  host: { class: 'allow-event-propagate output' },
})
export class NgFlowDesignerOutputDirective implements CyElement, OnInit, OnChanges, OnDestroy {
  @Input('ngFlowDesignerOutput') id: string;
  @Input() target?: string;
  @Input() showArrow = true;
  @Output() targetChange = new EventEmitter<string | undefined>();

  @ContentChild(NgFlowDesignerEdgeControllerDirective, { static: false })
  private controller: NgFlowDesignerEdgeControllerDirective;
  node?: NgFlowDesignerNodeDirective;
  isRegistered = false;
  private cy: cytoscape.Core;
  private cyCurrentTarget?: string;
  private destroy$ = new Subject<boolean>();

  constructor(
    public host: ElementRef,
    public parentNode: NgFlowDesignerNodeDirective,
    private designerComponent: NgFlowDesignerComponent,
    private ngFlowDesignerService: NgFlowDesignerService,
    private ngZone: NgZone,
  ) {}

  setTarget(nodeId?: string, emit = true) {
    this.cy.remove(this.getCyElement().connectedEdges());

    this.target = nodeId;
    this.cyCurrentTarget = this.target;

    if (emit) {
      this.targetChange.emit(this.target);
    }

    if (this.target && this.showArrow) {
      this.addCyEdge(this.target);
    }

    this.ngZone.run(() => {});
  }

  ngOnInit(): void {
    this.registerCy(this.designerComponent.cy);
    this.designerComponent.forceRender();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.target && !changes.target.firstChange) {
      this.target = changes.target.currentValue;
      this.setTarget(this.target, false);
    }
  }

  ngOnDestroy(): void {
    this.cy.remove(this.getCyElement());
    this.designerComponent.forceRender();
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  getCyElement(): cytoscape.CollectionReturnValue {
    return this.cy.getElementById(this.id);
  }

  registerCy(cy: cytoscape.Core): void {
    this.cy = cy;
    // @ts-ignore
    this.cy.add({
      data: {
        id: this.id,
        directive: this,
        isOutput: true,
      },
      classes: ['output'],
    });
    this.getCyElement().ungrabify();
    if (this.target) {
      setTimeout(() => {
        this.addCyEdge(this.target);
      });
    }
  }

  private addCyEdge(target) {
    this.cy.add({
      data: {
        source: this.id,
        target,
        controller: this.controller,
        showArrow: this.showArrow,
      },
    });

    this.controller.registerCy(this.cy);
  }
}
